import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { Button, Col, Input, Row, Spinner, Table } from "reactstrap";
import { updateProfilePicture } from "store/actions/settingAction";
import defaultLogo from "../../assets/img/Mpink.png";
import PopUp from "./PopUp";
import usePermissions from "hooks/usePermissions";

const CustomizationTable = ({
  data,
  logo,
  addToggle,
  editToggle,
  deleteToggle,
  setEditData,
  setIndex,
}) => {
  const {
    add: addAccess,
    get: getAccess,
    edit: editAccess,
    delete: deleteAccess,
  } = usePermissions();
  const dispatch = useDispatch();
  const inputRef = useRef(null);
  const { user } = useSelector((state) => state.auth);
  const { loading } = useSelector((state) => state.setting);
  const [colorSelect, setColorSelect] = useState(false);
  const [customerSelect, setCustomerSelect] = useState(false);
  const [adminColor, setadminColor] = useState("");
  const [customerColor, setCustomerColor] = useState("");

  useEffect(() => {
    setadminColor(user?.adminColor || "#d70365");
    setCustomerColor(user?.customerColor || "#d70365");
  }, [user]);

  const togglePopup = () => {
    setColorSelect(!colorSelect);
  };
  const togglePopupCustomer = () => {
    setCustomerSelect(!customerSelect);
  };
  const [img, setImages] = useState();

  const handleUpdateLogo = (e) => {
    let item2 = {
      id: user?.restaurantID,
      img: e.target.files[0],
    };
    setImages(e.target.files[0]);
    let MAX_FILE_SIZE = 1024 * 1024;
    const fileSizeKiloBytes = e.target.files[0].size;
    if (fileSizeKiloBytes > MAX_FILE_SIZE) {
      toast.warn("File size is greater than 1MB");
    } else {
      dispatch(updateProfilePicture(item2));
    }
  };
  return (
    <>
      <Row className="pb-5 px-md-3 px-1">
        <div className="col">
          <div className="d-flex pb-md-2 pb-0 flex-row justify-content-between align-items-center">
            <h3 className="pt-2 px-1">Banner</h3>
            {data && data.length === 0 && addAccess && (
              <Button
                color="primary"
                className="mr-2"
                size="sm"
                onClick={addToggle}
              >
                Add Banner
              </Button>
            )}
          </div>

          <div className="border border-gray-600 rounded">
            <Table className="align-items-center table-flush" responsive>
              <thead className="thead-light">
                <tr>
                  <th scope="col">Image</th>
                  {(editAccess || deleteAccess) && <th scope="col">Actions</th>}
                </tr>
              </thead>
              <tbody>
                {getAccess && data && data.length > 0 ? (
                  data.map((el, id) => {
                    return (
                      <tr key={id}>
                        <th scope="row">
                          <img
                            src={el}
                            style={{ width: "70px", height: "70px" }}
                            alt="Banner "
                            className="rounded"
                          />
                        </th>
                        {(editAccess || deleteAccess) && (
                          <td>
                            {editAccess && (
                              <Button
                                className="btn-sm"
                                color="primary"
                                onClick={() => {
                                  setIndex(id);
                                  setEditData(el);
                                  editToggle();
                                }}
                              >
                                Edit
                              </Button>
                            )}
                            {deleteAccess && (
                              <Button
                                className="btn-sm"
                                color="danger"
                                onClick={() => {
                                  setEditData(el);
                                  deleteToggle();
                                }}
                              >
                                Delete
                              </Button>
                            )}
                          </td>
                        )}
                      </tr>
                    );
                  })
                ) : (
                  <tr>
                    <td colSpan="6" className="text-center">
                      No banner added
                    </td>
                  </tr>
                )}
              </tbody>
            </Table>
          </div>
          <div className="pb-3 mt-4">
            <div className="d-flex justify-content-between w-100 mx-1">
              <h3 className="px-1">Replace Your logo</h3>
            </div>
            <div
              style={{
                position: "relative",
                width: "70px",
                height: "70px",
              }}
            >
              {loading ? (
                <div className="d-flex py-3 justify-content-center align-items-center">
                  <Spinner size="sm" color="primary" />
                </div>
              ) : (
                <img
                  className="ml-3 img-fluid rounded"
                  style={{
                    width: "70px",
                    height: "70px",
                  }}
                  src={(img && URL.createObjectURL(img)) || logo || defaultLogo}
                  alt="Logo"
                />
              )}

              <>
                {editAccess && !loading && (
                  <>
                    <i
                      className="fas fa-edit  text-primary bg-white rounded-circle p-1 cursor-pointer"
                      onClick={() => {
                        inputRef.current.click();
                      }}
                      style={{
                        position: "absolute",
                        right: "-23px",
                        bottom: "1px",
                        border: "1px solid #ffff",
                      }}
                    ></i>
                    <input
                      type="file"
                      hidden
                      ref={inputRef}
                      onChange={handleUpdateLogo}
                    />
                  </>
                )}
              </>
            </div>
          </div>
          <div className="">
            <div className="d-flex align-items-center">
              <h3 className="px-1 pt-2">Admin Color</h3>
              <div
                className="mx-2"
                style={{
                  height: "30px",
                  width: "30px",
                  background: `${adminColor}`,
                  borderRadius: "50%",
                }}
              ></div>
            </div>
            {colorSelect && (
              <PopUp
                id={"admin"}
                handleClose={togglePopup}
                color={adminColor}
                setColor={setadminColor}
                customerColor={customerColor}
                adminColor={adminColor}
              />
            )}

            <Row className="d-flex justify-content-center align-items-center">
              <Col>
                <Input type="text" value={adminColor} disabled />
              </Col>
              <Col>
                {editAccess && (
                  <Button
                    color="primary"
                    onClick={() => setColorSelect(!colorSelect)}
                  >
                    Select
                  </Button>
                )}
              </Col>
            </Row>
            <div className="d-flex align-items-center">
              <h3 className="px-1 pt-2">Customer Site Color</h3>
              <div
                className="mx-2"
                style={{
                  height: "30px",
                  width: "30px",
                  background: `${customerColor}`,
                  borderRadius: "50%",
                }}
              ></div>
            </div>
            <Row className="d-flex justify-content-center align-items-center">
              <Col>
                <Input type="text" value={customerColor} disabled />
              </Col>
              <Col>
                {editAccess && (
                  <Button
                    color="primary"
                    onClick={() => setCustomerSelect(!customerSelect)}
                  >
                    Select
                  </Button>
                )}
              </Col>
            </Row>
            {customerSelect && (
              <PopUp
                id={"customer"}
                handleClose={togglePopupCustomer}
                color={customerColor}
                setColor={setCustomerColor}
                customerColor={customerColor}
                adminColor={adminColor}
              />
            )}
          </div>
        </div>
      </Row>
    </>
  );
};

export default CustomizationTable;
